import { useEffect, useState } from 'react';

import { Breakpoint, UseBreakpointReturns } from './';

const breakpoints: { minWidth: number; bp: Breakpoint }[] = [
  { minWidth: 1024, bp: 'desktop' },
  { minWidth: 768, bp: 'tablet' },
  { minWidth: 0, bp: 'mobile' },
];

const getBreakpoint = (): Breakpoint => {
  for (let i of breakpoints) {
    const width = i.minWidth;
    if (window.innerWidth > width) return i.bp;
  }
};

export function useBreakpoint(): UseBreakpointReturns {
  const [bp, setBp] = useState<Breakpoint>(null);
  useEffect(() => {
    const r = () => {
      setBp(getBreakpoint());
    };
    window.addEventListener('resize', r);
    r();
    return () => {
      window.removeEventListener('resize', r);
    };
  }, []);
  return [bp] as const;
}
